'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPDATE_VIEW = exports.UPDATE_VIEW = 'UPDATE_VIEW';